import { DocumentList } from "@l2r-front/l2r-app-doc"
import { styled } from "@l2r-front/l2r-ui"

export const List = styled(DocumentList)(() => ({
    flex: 1,
}))